import { Toast, Tooltip } from "./_bootstrap";
import Swiper, { Navigation, Autoplay } from "swiper";

(function () {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll(".toast")
    .forEach((toastElement) => new Toast(toastElement));

  // LOGOS SLIDER initialization
  const swiper = new Swiper(".swiper", {
    loop: true,
	speed: 1000,
	autoplay: {
	  delay: 2500,
	  disableOnInteraction: false,
	},
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    modules: [Navigation, Autoplay],
  });
})();
